module.exports = __webpack_public_path__ + "static/media/crowderia-logo.9750000f.png";